import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-marker',{attrs:{"lat-lng":_vm.latLon},on:{"click":_vm.onClick}},[_c('l-tooltip',{attrs:{"options":{ direction: 'top', offset: [0, -24] }}},[_c('strong',[_vm._v(_vm._s(_vm.label))])]),_c('l-icon',{attrs:{"icon-anchor":[12, 24]}},[_c(VIcon,[_vm._v(_vm._s(_vm.icon))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }